import {AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { SessionService } from '@edl-development/edl-common';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
@Component({
    selector: 'edl-print',
    templateUrl: './edl-print.component.html',
    styleUrls: ['./edl-print.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EdlPrintComponent implements OnInit, OnDestroy, AfterViewInit {
    // PUBLIC FOR TESTING PURPOSES
    public displayPrintSub: Subscription;
    public isPageInitializedObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private sessionService: SessionService) {}

    ngOnInit(): void {
        this.displayPrintSub = combineLatest([
            this.isPageInitializedObservable.asObservable(),
            this.sessionService.getIsAppLoadingObservable()
        ]).pipe(
            takeWhile(([isPageInitialized, isAppLoading]) => !isPageInitialized || isAppLoading, true)
        ).subscribe(([isPageInitialized, isAppLoading]) => {
            if (isPageInitialized && !isAppLoading) {
                // NEED TO WAIT HALF A SECOND FOR THE SPINNER TO COMPLETELY BE REMOVED FROM VIEWPORT
                setTimeout(() => window.print(), 500);
            }
        });
    
    }
    ngAfterViewInit() {
        this.isPageInitializedObservable.next(true);
    }

    ngOnDestroy() {
        this.isPageInitializedObservable.unsubscribe();
        this.displayPrintSub.unsubscribe();
    }


}